// extracted by mini-css-extract-plugin
export default {"button":"HollowButton_button__gaHWO","button--active":"HollowButton_button--active__iAiif"};